import React, { useEffect, useState } from "react";
import {
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { isArray, isEmpty } from "lodash";
import { CircularProgress } from "@mui/material";
import { getApiData } from "../../../../utils/APIHelper";
import { Setting } from "../../../../utils/Setting";
import ProjectUpdateDetails from "./ProjectUpdateDetails";

export default function ProjectUpdateRoute() {
  const { id, updateId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const updateDate = searchParams.get("date") || undefined;
  const scopeId = searchParams.get("scopeId") || undefined;

  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const response = await getApiData(
          `${Setting.endpoints.getProject}?proposal_id=${id}`,
          "GET",
          {}
        );
        if (
          !cancelled &&
          response?.success &&
          isArray(response.data) &&
          !isEmpty(response.data)
        ) {
          setDetails(response.data[0]);
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  const handleBack = () => {
    navigate(`/project/details/${id}/project-updates`);
  };

  if (loading || !details) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "2vh 2vw",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      <ProjectUpdateDetails
        projectId={details?.id}
        projectDetails={details}
        updateIdFromUrl={updateId}
        updateDateFromUrl={updateDate}
        scopeIdFromUrl={scopeId}
        onBack={handleBack}
      />
    </div>
  );
}
